import { getUnleashOverride } from '@/utils/unleashOverride.util'

const OFFLINE_PRESENTING_FLAG = 'PRE-204-offline-presenting'

const UNLEASH_STORED_TOGGLES_KEY = 'unleash:repository:repo'

let decidedAtBoot = null

const readStoredToggle = () => {
  try {
    const raw = window.localStorage.getItem(UNLEASH_STORED_TOGGLES_KEY)
    if (!raw || !raw.includes(OFFLINE_PRESENTING_FLAG)) return false
    const toggles = JSON.parse(raw)
    return Array.isArray(toggles) && toggles.some((toggle) => toggle.name === OFFLINE_PRESENTING_FLAG && toggle.enabled)
  } catch (error) {
    return false
  }
}

/**
 * Whether the offline-presenting flag was on the last time Unleash stored its toggles. Boot code
 * needs an answer before Unleash is ready, so the stored value decides and is read once per load;
 * a flag flip therefore takes effect one load late. A missing flag counts as off.
 */
export const isOfflinePresentingStoredOn = () => {
  const override = getUnleashOverride(OFFLINE_PRESENTING_FLAG)
  if (override) return Boolean(override.enabled)
  if (decidedAtBoot === null) decidedAtBoot = readStoredToggle()
  return decidedAtBoot
}
